document.getElementById("toggle-captions").addEventListener("change", function () {
  var figcaptions = document.querySelectorAll("figcaption");
  figcaptions.forEach(function (figcaption) {
    if (this.checked) {
      figcaption.style.opacity = "1";
      figcaption.style.pointerEvents = "auto";
    } else {
      figcaption.style.opacity = "0";
      figcaption.style.pointerEvents = "none";
    }
  }, this);
});
